"use client";
import { Item } from "types/Item";
import ScanCounts from "./api/ScanDatas";

export default class ScanDataService {
	public static readonly instance = new this();

	private constructor() {}

	public async add(item: Item, session_id: string, device: string) {
		await ScanCounts.getInstance().add(item.sku, item.nom_produit_fr, session_id, device);
	}
}
